import { Mui, MuiIcons } from "@leap4/frontend";
import { useThemeMode } from "../../theme/ThemeModeProvider";
import { CampaignScopeSwitcher } from "./CampaignScopeSwitcher";
import { OrganizationSwitcher } from "./OrganizationSwitcher";
import { ProfileMenu } from "./ProfileMenu";

const { AppBar, Toolbar, IconButton, Box, Tooltip } = Mui;
const { Menu: MenuIcon, DarkModeOutlined, LightModeOutlined } = MuiIcons;

interface IAppShellTopBarProps {
    onMenuClick: () => void;
    isMobile: boolean;
    email: string;
}

export const AppShellTopBar = ({ onMenuClick, isMobile, email }: IAppShellTopBarProps) => {
    const { mode, toggleMode } = useThemeMode();
    const nextLabel = mode === "dark" ? "Switch to light theme" : "Switch to dark theme";

    return (
        <AppBar position="static" color="default" elevation={0} sx={{ borderBottom: 1, borderColor: "divider", bgcolor: "background.paper" }}>
            <Toolbar sx={{ minHeight: 64, gap: 1 }}>
                {isMobile && (
                    <IconButton edge="start" onClick={onMenuClick} aria-label="Open navigation">
                        <MenuIcon />
                    </IconButton>
                )}
                <Box sx={{ flexGrow: 1, display: "flex", alignItems: "center", gap: 1, minWidth: 0 }}>
                    <CampaignScopeSwitcher />
                </Box>
                <Tooltip title={nextLabel}>
                    <IconButton onClick={toggleMode} aria-label={nextLabel}>
                        {mode === "dark" ? <LightModeOutlined /> : <DarkModeOutlined />}
                    </IconButton>
                </Tooltip>
                <OrganizationSwitcher />
                <ProfileMenu email={email} />
            </Toolbar>
        </AppBar>
    );
};
